<template>
<a class="linkServices" :href="navLinks.logout" v-if="isAuthenticated">
	<div class="frame"></div>
	<span class="text">Logout</span>
</a>
<a class="linkServices" :href="navLinks.login" v-else-if="!isAuthenticated">
	<!--<div class="frame"></div>-->
	<span class="text">Login</span>
</a>
</template>

<script>
// import Vue from 'vue'

export default {
	name: 'login-template',
	data () {
		return {
			isAuthenticated: false
		}
	},
	created () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		this.$e24Common.security.getSharedLoginStatus().then((status) => {
			// console.log('isAuthenticated', status)
			this.isAuthenticated = status.status
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/loginButton.vue